// generated with @7nohe/openapi-react-query-codegen@1.6.1

import type { UseMutationOptions, UseQueryOptions } from '@tanstack/react-query'
import { useMutation, useQuery } from '@tanstack/react-query'

import {
  AdminCompaniesService,
  AdminStatsService,
  AdminUsersService,
  AdminWhitelistService,
  AdvisorsAppointmentsService,
  AdvisorService,
  AdvisorsService,
  AppointmentsService,
  BankingService,
  BudgetService,
  EmailNotificationsService,
  EmailPreviewService,
  EmployerAdvisorsService,
  EmployerStatsService,
  EmployerUsersService,
  FileService,
  GoalsService,
  InsightsService,
  MessageService,
  NotificationsService,
  OnboardingService,
  QueueService,
  RolanWealthService,
  SupportService,
  TransactionService,
  UserService,
} from '../requests/services.gen'
import type {
  BulkEditTransactionsDTO,
  BulkWhitelistEmailsDTO,
  ChangePasswordDTO,
  ChangeUserRoleDTO,
  ClaimGoalAmountDTO,
  CreateAppointmentDTO,
  CreateBudgetDTO,
  CreateGoalDTO,
  CreateGoalRecommendationDTO,
  CreateGoalStepDTO,
  CreateLinkTokenDTO,
  CreateResetPasswordTokenDTO,
  CreateSupportTicketDTO,
  CreateUserDTO,
  EditProfileDTO,
  EditTransactionDTO,
  GetPresignedURLDTO,
  GrantAdvisorAccessDto,
  OnboardingDTO,
  ReorderGoalStepsDTO,
  ResetPasswordDTO,
  StoreBankAccountDTO,
  StoreManualAccountDTO,
  UpdateGoalStepDTO,
  UserLoginDTO,
  VerifyEmailDTO,
  VerifyUserAdminDTO,
} from '../requests/types.gen'
import * as Common from './common'

export const useUserServiceUserControllerGetLoggedUser = <
  TData = Common.UserServiceUserControllerGetLoggedUserDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseUserServiceUserControllerGetLoggedUserKeyFn(queryKey),
    queryFn: () => UserService.userControllerGetLoggedUser() as TData,
    ...options,
  })
export const useMessageServiceMessageControllerGetAllMessages = <
  TData = Common.MessageServiceMessageControllerGetAllMessagesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    recipientId,
    skip,
    take,
  }: {
    recipientId: number
    skip: number
    take: number
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseMessageServiceMessageControllerGetAllMessagesKeyFn(
      { recipientId, skip, take },
      queryKey,
    ),
    queryFn: () =>
      MessageService.messageControllerGetAllMessages({
        recipientId,
        skip,
        take,
      }) as TData,
    ...options,
  })
export const useQueueServiceQueueControllerProcessJobs = <
  TData = Common.QueueServiceQueueControllerProcessJobsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseQueueServiceQueueControllerProcessJobsKeyFn(queryKey),
    queryFn: () => QueueService.queueControllerProcessJobs() as TData,
    ...options,
  })
export const useQueueServiceQueueControllerSyncTransactions = <
  TData = Common.QueueServiceQueueControllerSyncTransactionsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseQueueServiceQueueControllerSyncTransactionsKeyFn(queryKey),
    queryFn: () => QueueService.queueControllerSyncTransactions() as TData,
    ...options,
  })
export const useQueueServiceQueueControllerMonthlyJobs = <
  TData = Common.QueueServiceQueueControllerMonthlyJobsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseQueueServiceQueueControllerMonthlyJobsKeyFn(queryKey),
    queryFn: () => QueueService.queueControllerMonthlyJobs() as TData,
    ...options,
  })
export const useTransactionServiceTransactionControllerGetTransactions = <
  TData = Common.TransactionServiceTransactionControllerGetTransactionsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    endDate,
    startDate,
    type,
  }: {
    endDate: string
    startDate: string
    type: 'income' | 'spending'
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseTransactionServiceTransactionControllerGetTransactionsKeyFn(
        { endDate, startDate, type },
        queryKey,
      ),
    queryFn: () =>
      TransactionService.transactionControllerGetTransactions({
        endDate,
        startDate,
        type,
      }) as TData,
    ...options,
  })
export const useBankingServiceBankingControllerGetManualAccount = <
  TData = Common.BankingServiceBankingControllerGetManualAccountDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    accountId,
  }: {
    accountId: string
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseBankingServiceBankingControllerGetManualAccountKeyFn(
      { accountId },
      queryKey,
    ),
    queryFn: () =>
      BankingService.bankingControllerGetManualAccount({ accountId }) as TData,
    ...options,
  })
export const useBankingServiceBankingControllerGetAccounts = <
  TData = Common.BankingServiceBankingControllerGetAccountsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseBankingServiceBankingControllerGetAccountsKeyFn(queryKey),
    queryFn: () => BankingService.bankingControllerGetAccounts() as TData,
    ...options,
  })
export const useBankingServiceBankingControllerGetManualAccounts = <
  TData = Common.BankingServiceBankingControllerGetManualAccountsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseBankingServiceBankingControllerGetManualAccountsKeyFn(queryKey),
    queryFn: () => BankingService.bankingControllerGetManualAccounts() as TData,
    ...options,
  })
export const useBankingServiceBankingControllerWebhook = <
  TData = Common.BankingServiceBankingControllerWebhookDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseBankingServiceBankingControllerWebhookKeyFn(queryKey),
    queryFn: () => BankingService.bankingControllerWebhook() as TData,
    ...options,
  })
export const useBankingServiceBankingControllerGetLinearStats = <
  TData = Common.BankingServiceBankingControllerGetLinearStatsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    period,
    type,
  }: {
    period: 'half-year' | 'month' | 'quarter' | 'year'
    type: 'assets' | 'debt' | 'net-worth'
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseBankingServiceBankingControllerGetLinearStatsKeyFn(
      { period, type },
      queryKey,
    ),
    queryFn: () =>
      BankingService.bankingControllerGetLinearStats({ period, type }) as TData,
    ...options,
  })
export const useBankingServiceBankingControllerGetDonutStats = <
  TData = Common.BankingServiceBankingControllerGetDonutStatsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    type,
  }: {
    type: 'assets' | 'debt' | 'net-worth'
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseBankingServiceBankingControllerGetDonutStatsKeyFn(
      { type },
      queryKey,
    ),
    queryFn: () =>
      BankingService.bankingControllerGetDonutStats({ type }) as TData,
    ...options,
  })
export const useBankingServiceBankingControllerGetIncomeStats = <
  TData = Common.BankingServiceBankingControllerGetIncomeStatsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    endDate,
    startDate,
  }: {
    endDate: string
    startDate: string
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseBankingServiceBankingControllerGetIncomeStatsKeyFn(
      { endDate, startDate },
      queryKey,
    ),
    queryFn: () =>
      BankingService.bankingControllerGetIncomeStats({
        endDate,
        startDate,
      }) as TData,
    ...options,
  })
export const useBankingServiceBankingControllerGetSpendingStats = <
  TData = Common.BankingServiceBankingControllerGetSpendingStatsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    endDate,
    startDate,
  }: {
    endDate: string
    startDate: string
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseBankingServiceBankingControllerGetSpendingStatsKeyFn(
      { endDate, startDate },
      queryKey,
    ),
    queryFn: () =>
      BankingService.bankingControllerGetSpendingStats({
        endDate,
        startDate,
      }) as TData,
    ...options,
  })
export const useGoalsServiceGoalsControllerGet = <
  TData = Common.GoalsServiceGoalsControllerGetDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    goalId,
  }: {
    goalId: number
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGoalsServiceGoalsControllerGetKeyFn(
      { goalId },
      queryKey,
    ),
    queryFn: () => GoalsService.goalsControllerGet({ goalId }) as TData,
    ...options,
  })
export const useGoalsServiceGoalsControllerGetAll = <
  TData = Common.GoalsServiceGoalsControllerGetAllDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    orderBy,
    status,
  }: {
    orderBy: 'deadline' | 'new_first' | 'old_first'
    status?: 'ACTIVE' | 'COMPLETED' | 'ARCHIVED'
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGoalsServiceGoalsControllerGetAllKeyFn(
      { orderBy, status },
      queryKey,
    ),
    queryFn: () =>
      GoalsService.goalsControllerGetAll({ orderBy, status }) as TData,
    ...options,
  })
export const useGoalsServiceGoalsControllerGetRecommendations = <
  TData = Common.GoalsServiceGoalsControllerGetRecommendationsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseGoalsServiceGoalsControllerGetRecommendationsKeyFn(queryKey),
    queryFn: () => GoalsService.goalsControllerGetRecommendations() as TData,
    ...options,
  })
export const useGoalsServiceGoalsControllerGetSavedValue = <
  TData = Common.GoalsServiceGoalsControllerGetSavedValueDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    endDate,
    startDate,
  }: {
    endDate: string
    startDate: string
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGoalsServiceGoalsControllerGetSavedValueKeyFn(
      { endDate, startDate },
      queryKey,
    ),
    queryFn: () =>
      GoalsService.goalsControllerGetSavedValue({
        endDate,
        startDate,
      }) as TData,
    ...options,
  })
export const useGoalsServiceGoalsControllerGetSteps = <
  TData = Common.GoalsServiceGoalsControllerGetStepsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    goalId,
  }: {
    goalId: number
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGoalsServiceGoalsControllerGetStepsKeyFn(
      { goalId },
      queryKey,
    ),
    queryFn: () => GoalsService.goalsControllerGetSteps({ goalId }) as TData,
    ...options,
  })
export const useNotificationsServiceNotificationControllerGetAll = <
  TData = Common.NotificationsServiceNotificationControllerGetAllDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    action,
    status,
  }: {
    action?: 'CLAIM_MONTHLY_REMINDER'
    status?: 'UNREAD' | 'READ'
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseNotificationsServiceNotificationControllerGetAllKeyFn(
      { action, status },
      queryKey,
    ),
    queryFn: () =>
      NotificationsService.notificationControllerGetAll({
        action,
        status,
      }) as TData,
    ...options,
  })
export const useFileServiceFileControllerGetSignedUrl = <
  TData = Common.FileServiceFileControllerGetSignedUrlDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    filename,
  }: {
    filename: string
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseFileServiceFileControllerGetSignedUrlKeyFn(
      { filename },
      queryKey,
    ),
    queryFn: () =>
      FileService.fileControllerGetSignedUrl({ filename }) as TData,
    ...options,
  })
export const useBudgetServiceBudgetControllerGetBudget = <
  TData = Common.BudgetServiceBudgetControllerGetBudgetDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    budgetId,
  }: {
    budgetId: number
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseBudgetServiceBudgetControllerGetBudgetKeyFn(
      { budgetId },
      queryKey,
    ),
    queryFn: () =>
      BudgetService.budgetControllerGetBudget({ budgetId }) as TData,
    ...options,
  })
export const useBudgetServiceBudgetControllerGetAllBudgets = <
  TData = Common.BudgetServiceBudgetControllerGetAllBudgetsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    endDate,
    startDate,
  }: {
    endDate: string
    startDate: string
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseBudgetServiceBudgetControllerGetAllBudgetsKeyFn(
      { endDate, startDate },
      queryKey,
    ),
    queryFn: () =>
      BudgetService.budgetControllerGetAllBudgets({
        endDate,
        startDate,
      }) as TData,
    ...options,
  })
export const useOnboardingServiceOnboardingControllerGetAnswers = <
  TData = Common.OnboardingServiceOnboardingControllerGetAnswersDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseOnboardingServiceOnboardingControllerGetAnswersKeyFn(queryKey),
    queryFn: () => OnboardingService.onboardingControllerGetAnswers() as TData,
    ...options,
  })
export const useAdvisorServiceAdvisorControllerGetAllAdvisors = <
  TData = Common.AdvisorServiceAdvisorControllerGetAllAdvisorsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    query,
  }: {
    query?: string
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAdvisorServiceAdvisorControllerGetAllAdvisorsKeyFn(
      { query },
      queryKey,
    ),
    queryFn: () =>
      AdvisorService.advisorControllerGetAllAdvisors({ query }) as TData,
    ...options,
  })
export const useAdvisorsServiceAdvisorUsersControllerGetUsers = <
  TData = Common.AdvisorsServiceAdvisorUsersControllerGetUsersDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAdvisorsServiceAdvisorUsersControllerGetUsersKeyFn(queryKey),
    queryFn: () => AdvisorsService.advisorUsersControllerGetUsers() as TData,
    ...options,
  })
export const useAdvisorsServiceAdvisorUsersControllerGetUserById = <
  TData = Common.AdvisorsServiceAdvisorUsersControllerGetUserByIdDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    userId,
  }: {
    userId: number
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAdvisorsServiceAdvisorUsersControllerGetUserByIdKeyFn(
      { userId },
      queryKey,
    ),
    queryFn: () =>
      AdvisorsService.advisorUsersControllerGetUserById({ userId }) as TData,
    ...options,
  })
export const useAdvisorsServiceAdvisorUsersControllerGetChatUsers = <
  TData = Common.AdvisorsServiceAdvisorUsersControllerGetChatUsersDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    query,
  }: {
    query?: string
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAdvisorsServiceAdvisorUsersControllerGetChatUsersKeyFn(
      { query },
      queryKey,
    ),
    queryFn: () =>
      AdvisorsService.advisorUsersControllerGetChatUsers({ query }) as TData,
    ...options,
  })
export const useAdvisorsServiceAdvisorUsersControllerGetUserQuestionnaire = <
  TData = Common.AdvisorsServiceAdvisorUsersControllerGetUserQuestionnaireDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    userId,
  }: {
    userId: number
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAdvisorsServiceAdvisorUsersControllerGetUserQuestionnaireKeyFn(
        { userId },
        queryKey,
      ),
    queryFn: () =>
      AdvisorsService.advisorUsersControllerGetUserQuestionnaire({
        userId,
      }) as TData,
    ...options,
  })
export const useAdvisorsServiceAdvisorUsersControllerGetDonutStats = <
  TData = Common.AdvisorsServiceAdvisorUsersControllerGetDonutStatsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    type,
    userId,
  }: {
    type: 'assets' | 'debt' | 'net-worth'
    userId: number
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAdvisorsServiceAdvisorUsersControllerGetDonutStatsKeyFn(
      { type, userId },
      queryKey,
    ),
    queryFn: () =>
      AdvisorsService.advisorUsersControllerGetDonutStats({
        type,
        userId,
      }) as TData,
    ...options,
  })
export const useAdvisorsServiceAdvisorUsersControllerGetIncomeStats = <
  TData = Common.AdvisorsServiceAdvisorUsersControllerGetIncomeStatsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    endDate,
    startDate,
    userId,
  }: {
    endDate: string
    startDate: string
    userId: number
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAdvisorsServiceAdvisorUsersControllerGetIncomeStatsKeyFn(
        { endDate, startDate, userId },
        queryKey,
      ),
    queryFn: () =>
      AdvisorsService.advisorUsersControllerGetIncomeStats({
        endDate,
        startDate,
        userId,
      }) as TData,
    ...options,
  })
export const useAdvisorsServiceAdvisorUsersControllerGetSpendingStats = <
  TData = Common.AdvisorsServiceAdvisorUsersControllerGetSpendingStatsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    endDate,
    startDate,
    userId,
  }: {
    endDate: string
    startDate: string
    userId: number
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAdvisorsServiceAdvisorUsersControllerGetSpendingStatsKeyFn(
        { endDate, startDate, userId },
        queryKey,
      ),
    queryFn: () =>
      AdvisorsService.advisorUsersControllerGetSpendingStats({
        endDate,
        startDate,
        userId,
      }) as TData,
    ...options,
  })
export const useAdvisorsServiceAdvisorUsersControllerGetLinearStats = <
  TData = Common.AdvisorsServiceAdvisorUsersControllerGetLinearStatsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    period,
    type,
    userId,
  }: {
    period: 'half-year' | 'month' | 'quarter' | 'year'
    type: 'assets' | 'debt' | 'net-worth'
    userId: number
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAdvisorsServiceAdvisorUsersControllerGetLinearStatsKeyFn(
        { period, type, userId },
        queryKey,
      ),
    queryFn: () =>
      AdvisorsService.advisorUsersControllerGetLinearStats({
        period,
        type,
        userId,
      }) as TData,
    ...options,
  })
export const useAdvisorsServiceAdvisorUsersControllerGetBudgets = <
  TData = Common.AdvisorsServiceAdvisorUsersControllerGetBudgetsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    endDate,
    startDate,
    userId,
  }: {
    endDate: string
    startDate: string
    userId: number
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAdvisorsServiceAdvisorUsersControllerGetBudgetsKeyFn(
      { endDate, startDate, userId },
      queryKey,
    ),
    queryFn: () =>
      AdvisorsService.advisorUsersControllerGetBudgets({
        endDate,
        startDate,
        userId,
      }) as TData,
    ...options,
  })
export const useAdvisorsServiceAdvisorUsersControllerGetGoals = <
  TData = Common.AdvisorsServiceAdvisorUsersControllerGetGoalsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    userId,
  }: {
    userId: number
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAdvisorsServiceAdvisorUsersControllerGetGoalsKeyFn(
      { userId },
      queryKey,
    ),
    queryFn: () =>
      AdvisorsService.advisorUsersControllerGetGoals({ userId }) as TData,
    ...options,
  })
export const useAdvisorsServiceAdvisorUsersControllerGetAccounts = <
  TData = Common.AdvisorsServiceAdvisorUsersControllerGetAccountsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    userId,
  }: {
    userId: number
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAdvisorsServiceAdvisorUsersControllerGetAccountsKeyFn(
      { userId },
      queryKey,
    ),
    queryFn: () =>
      AdvisorsService.advisorUsersControllerGetAccounts({ userId }) as TData,
    ...options,
  })
export const useAdvisorsServiceAdvisorUsersControllerGetTransactions = <
  TData = Common.AdvisorsServiceAdvisorUsersControllerGetTransactionsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    endDate,
    startDate,
    type,
    userId,
  }: {
    endDate: string
    startDate: string
    type: 'income' | 'spending'
    userId: number
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAdvisorsServiceAdvisorUsersControllerGetTransactionsKeyFn(
        { endDate, startDate, type, userId },
        queryKey,
      ),
    queryFn: () =>
      AdvisorsService.advisorUsersControllerGetTransactions({
        endDate,
        startDate,
        type,
        userId,
      }) as TData,
    ...options,
  })
export const useAdvisorsAppointmentsServiceAdvisorAppointmentsControllerGetAllAppointments =
  <
    TData = Common.AdvisorsAppointmentsServiceAdvisorAppointmentsControllerGetAllAppointmentsDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      limit,
      sort,
      userId,
    }: {
      limit?: number
      sort?: unknown
      userId?: number
    } = {},
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseAdvisorsAppointmentsServiceAdvisorAppointmentsControllerGetAllAppointmentsKeyFn(
          { limit, sort, userId },
          queryKey,
        ),
      queryFn: () =>
        AdvisorsAppointmentsService.advisorAppointmentsControllerGetAllAppointments(
          { limit, sort, userId },
        ) as TData,
      ...options,
    })
export const useAdminStatsServiceAdminStatsControllerGetUserStats = <
  TData = Common.AdminStatsServiceAdminStatsControllerGetUserStatsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    company,
    endDate,
    startDate,
  }: {
    company?: string
    endDate: string
    startDate: string
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAdminStatsServiceAdminStatsControllerGetUserStatsKeyFn(
      { company, endDate, startDate },
      queryKey,
    ),
    queryFn: () =>
      AdminStatsService.adminStatsControllerGetUserStats({
        company,
        endDate,
        startDate,
      }) as TData,
    ...options,
  })
export const useAdminStatsServiceAdminStatsControllerGetGenderStats = <
  TData = Common.AdminStatsServiceAdminStatsControllerGetGenderStatsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    company,
  }: {
    company?: string
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAdminStatsServiceAdminStatsControllerGetGenderStatsKeyFn(
        { company },
        queryKey,
      ),
    queryFn: () =>
      AdminStatsService.adminStatsControllerGetGenderStats({
        company,
      }) as TData,
    ...options,
  })
export const useAdminStatsServiceAdminStatsControllerGetRaceStats = <
  TData = Common.AdminStatsServiceAdminStatsControllerGetRaceStatsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    company,
  }: {
    company?: string
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAdminStatsServiceAdminStatsControllerGetRaceStatsKeyFn(
      { company },
      queryKey,
    ),
    queryFn: () =>
      AdminStatsService.adminStatsControllerGetRaceStats({ company }) as TData,
    ...options,
  })
export const useAdminStatsServiceAdminStatsControllerGetAgeStats = <
  TData = Common.AdminStatsServiceAdminStatsControllerGetAgeStatsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    company,
  }: {
    company?: string
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAdminStatsServiceAdminStatsControllerGetAgeStatsKeyFn(
      { company },
      queryKey,
    ),
    queryFn: () =>
      AdminStatsService.adminStatsControllerGetAgeStats({ company }) as TData,
    ...options,
  })
export const useAdminStatsServiceAdminStatsControllerGetIncomeStats = <
  TData = Common.AdminStatsServiceAdminStatsControllerGetIncomeStatsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    company,
  }: {
    company?: string
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAdminStatsServiceAdminStatsControllerGetIncomeStatsKeyFn(
        { company },
        queryKey,
      ),
    queryFn: () =>
      AdminStatsService.adminStatsControllerGetIncomeStats({
        company,
      }) as TData,
    ...options,
  })
export const useAdminStatsServiceAdminStatsControllerGetTopicsStats = <
  TData = Common.AdminStatsServiceAdminStatsControllerGetTopicsStatsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    company,
  }: {
    company?: string
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAdminStatsServiceAdminStatsControllerGetTopicsStatsKeyFn(
        { company },
        queryKey,
      ),
    queryFn: () =>
      AdminStatsService.adminStatsControllerGetTopicsStats({
        company,
      }) as TData,
    ...options,
  })
export const useAdminCompaniesServiceAdminCompaniesControllerGetCompanies = <
  TData = Common.AdminCompaniesServiceAdminCompaniesControllerGetCompaniesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAdminCompaniesServiceAdminCompaniesControllerGetCompaniesKeyFn(
        queryKey,
      ),
    queryFn: () =>
      AdminCompaniesService.adminCompaniesControllerGetCompanies() as TData,
    ...options,
  })
export const useEmployerStatsServiceEmployerStatsControllerGetUserStats = <
  TData = Common.EmployerStatsServiceEmployerStatsControllerGetUserStatsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    company,
    endDate,
    startDate,
  }: {
    company?: string
    endDate: string
    startDate: string
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseEmployerStatsServiceEmployerStatsControllerGetUserStatsKeyFn(
        { company, endDate, startDate },
        queryKey,
      ),
    queryFn: () =>
      EmployerStatsService.employerStatsControllerGetUserStats({
        company,
        endDate,
        startDate,
      }) as TData,
    ...options,
  })
export const useEmployerStatsServiceEmployerStatsControllerGetGenderStats = <
  TData = Common.EmployerStatsServiceEmployerStatsControllerGetGenderStatsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseEmployerStatsServiceEmployerStatsControllerGetGenderStatsKeyFn(
        queryKey,
      ),
    queryFn: () =>
      EmployerStatsService.employerStatsControllerGetGenderStats() as TData,
    ...options,
  })
export const useEmployerStatsServiceEmployerStatsControllerGetRaceStats = <
  TData = Common.EmployerStatsServiceEmployerStatsControllerGetRaceStatsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseEmployerStatsServiceEmployerStatsControllerGetRaceStatsKeyFn(
        queryKey,
      ),
    queryFn: () =>
      EmployerStatsService.employerStatsControllerGetRaceStats() as TData,
    ...options,
  })
export const useEmployerStatsServiceEmployerStatsControllerGetAgeStats = <
  TData = Common.EmployerStatsServiceEmployerStatsControllerGetAgeStatsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseEmployerStatsServiceEmployerStatsControllerGetAgeStatsKeyFn(
        queryKey,
      ),
    queryFn: () =>
      EmployerStatsService.employerStatsControllerGetAgeStats() as TData,
    ...options,
  })
export const useEmployerStatsServiceEmployerStatsControllerGetIncomeStats = <
  TData = Common.EmployerStatsServiceEmployerStatsControllerGetIncomeStatsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseEmployerStatsServiceEmployerStatsControllerGetIncomeStatsKeyFn(
        queryKey,
      ),
    queryFn: () =>
      EmployerStatsService.employerStatsControllerGetIncomeStats() as TData,
    ...options,
  })
export const useEmployerStatsServiceEmployerStatsControllerGetTopicStats = <
  TData = Common.EmployerStatsServiceEmployerStatsControllerGetTopicStatsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseEmployerStatsServiceEmployerStatsControllerGetTopicStatsKeyFn(
        queryKey,
      ),
    queryFn: () =>
      EmployerStatsService.employerStatsControllerGetTopicStats() as TData,
    ...options,
  })
export const useEmployerUsersServiceEmployerUsersControllerGetAllEmployees = <
  TData = Common.EmployerUsersServiceEmployerUsersControllerGetAllEmployeesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseEmployerUsersServiceEmployerUsersControllerGetAllEmployeesKeyFn(
        queryKey,
      ),
    queryFn: () =>
      EmployerUsersService.employerUsersControllerGetAllEmployees() as TData,
    ...options,
  })
export const useEmployerAdvisorsServiceEmployerAdvisorControllerGetAllAdvisors =
  <
    TData = Common.EmployerAdvisorsServiceEmployerAdvisorControllerGetAllAdvisorsDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseEmployerAdvisorsServiceEmployerAdvisorControllerGetAllAdvisorsKeyFn(
          queryKey,
        ),
      queryFn: () =>
        EmployerAdvisorsService.employerAdvisorControllerGetAllAdvisors() as TData,
      ...options,
    })
export const useInsightsServiceInsightsControllerGetInsights = <
  TData = Common.InsightsServiceInsightsControllerGetInsightsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
  }: {
    page: 'ACTION_PLAN' | 'BUDGET' | 'NET_WORTH' | 'DASHBOARD'
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseInsightsServiceInsightsControllerGetInsightsKeyFn(
      { page },
      queryKey,
    ),
    queryFn: () =>
      InsightsService.insightsControllerGetInsights({ page }) as TData,
    ...options,
  })
export const useAppointmentsServiceAppointmentsControllerGetAppointments = <
  TData = Common.AppointmentsServiceAppointmentsControllerGetAppointmentsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    limit,
    sort,
    userId,
  }: {
    limit?: number
    sort?: unknown
    userId?: number
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAppointmentsServiceAppointmentsControllerGetAppointmentsKeyFn(
        { limit, sort, userId },
        queryKey,
      ),
    queryFn: () =>
      AppointmentsService.appointmentsControllerGetAppointments({
        limit,
        sort,
        userId,
      }) as TData,
    ...options,
  })
export const useSupportServiceSupportControllerSearch = <
  TData = Common.SupportServiceSupportControllerSearchDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    query,
    type,
  }: {
    query?: string
    type?: 'account' | 'transaction'
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseSupportServiceSupportControllerSearchKeyFn(
      { query, type },
      queryKey,
    ),
    queryFn: () =>
      SupportService.supportControllerSearch({ query, type }) as TData,
    ...options,
  })
export const useEmailNotificationsServiceEmailNotificationsControllerEvaluate =
  <
    TData = Common.EmailNotificationsServiceEmailNotificationsControllerEvaluateDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseEmailNotificationsServiceEmailNotificationsControllerEvaluateKeyFn(
          queryKey,
        ),
      queryFn: () =>
        EmailNotificationsService.emailNotificationsControllerEvaluate() as TData,
      ...options,
    })
export const useEmailNotificationsServiceEmailNotificationsControllerDispatch =
  <
    TData = Common.EmailNotificationsServiceEmailNotificationsControllerDispatchDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseEmailNotificationsServiceEmailNotificationsControllerDispatchKeyFn(
          queryKey,
        ),
      queryFn: () =>
        EmailNotificationsService.emailNotificationsControllerDispatch() as TData,
      ...options,
    })
export const useEmailNotificationsServiceEmailNotificationsControllerBaseline =
  <
    TData = Common.EmailNotificationsServiceEmailNotificationsControllerBaselineDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseEmailNotificationsServiceEmailNotificationsControllerBaselineKeyFn(
          queryKey,
        ),
      queryFn: () =>
        EmailNotificationsService.emailNotificationsControllerBaseline() as TData,
      ...options,
    })
export const useEmailPreviewServiceEmailPreviewControllerSend = <
  TData = Common.EmailPreviewServiceEmailPreviewControllerSendDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    key,
  }: {
    key?: string
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseEmailPreviewServiceEmailPreviewControllerSendKeyFn(
      { key },
      queryKey,
    ),
    queryFn: () =>
      EmailPreviewService.emailPreviewControllerSend({ key }) as TData,
    ...options,
  })
export const useUserServiceUserControllerEditProfile = <
  TData = Common.UserServiceUserControllerEditProfileMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: EditProfileDTO
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: EditProfileDTO
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      UserService.userControllerEditProfile({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useBankingServiceBankingControllerCreateLinkToken = <
  TData = Common.BankingServiceBankingControllerCreateLinkTokenMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CreateLinkTokenDTO
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CreateLinkTokenDTO
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      BankingService.bankingControllerCreateLinkToken({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useBankingServiceBankingControllerCreateAccounts = <
  TData = Common.BankingServiceBankingControllerCreateAccountsMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: StoreBankAccountDTO
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: StoreBankAccountDTO
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      BankingService.bankingControllerCreateAccounts({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useBankingServiceBankingControllerCreateManualAccount = <
  TData = Common.BankingServiceBankingControllerCreateManualAccountMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: StoreManualAccountDTO
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: StoreManualAccountDTO
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      BankingService.bankingControllerCreateManualAccount({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useGoalsServiceGoalsControllerAdd = <
  TData = Common.GoalsServiceGoalsControllerAddMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CreateGoalDTO
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CreateGoalDTO
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      GoalsService.goalsControllerAdd({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useGoalsServiceGoalsControllerClaimAmount = <
  TData = Common.GoalsServiceGoalsControllerClaimAmountMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        goalId: number
        requestBody: ClaimGoalAmountDTO
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      goalId: number
      requestBody: ClaimGoalAmountDTO
    },
    TContext
  >({
    mutationFn: ({ goalId, requestBody }) =>
      GoalsService.goalsControllerClaimAmount({
        goalId,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useGoalsServiceGoalsControllerComplete = <
  TData = Common.GoalsServiceGoalsControllerCompleteMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        goalId: number
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      goalId: number
    },
    TContext
  >({
    mutationFn: ({ goalId }) =>
      GoalsService.goalsControllerComplete({
        goalId,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useGoalsServiceGoalsControllerArchive = <
  TData = Common.GoalsServiceGoalsControllerArchiveMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        goalId: number
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      goalId: number
    },
    TContext
  >({
    mutationFn: ({ goalId }) =>
      GoalsService.goalsControllerArchive({
        goalId,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useGoalsServiceGoalsControllerReactivate = <
  TData = Common.GoalsServiceGoalsControllerReactivateMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        goalId: number
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      goalId: number
    },
    TContext
  >({
    mutationFn: ({ goalId }) =>
      GoalsService.goalsControllerReactivate({
        goalId,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useGoalsServiceGoalsControllerAddStep = <
  TData = Common.GoalsServiceGoalsControllerAddStepMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        goalId: number
        requestBody: CreateGoalStepDTO
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      goalId: number
      requestBody: CreateGoalStepDTO
    },
    TContext
  >({
    mutationFn: ({ goalId, requestBody }) =>
      GoalsService.goalsControllerAddStep({
        goalId,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useGoalsServiceGoalsControllerToggleStep = <
  TData = Common.GoalsServiceGoalsControllerToggleStepMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        goalId: number
        stepId: number
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      goalId: number
      stepId: number
    },
    TContext
  >({
    mutationFn: ({ goalId, stepId }) =>
      GoalsService.goalsControllerToggleStep({
        goalId,
        stepId,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useFileServiceFileControllerGetPresignedUrl = <
  TData = Common.FileServiceFileControllerGetPresignedUrlMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: GetPresignedURLDTO
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: GetPresignedURLDTO
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      FileService.fileControllerGetPresignedUrl({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useBudgetServiceBudgetControllerAddBudget = <
  TData = Common.BudgetServiceBudgetControllerAddBudgetMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CreateBudgetDTO
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CreateBudgetDTO
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      BudgetService.budgetControllerAddBudget({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useRolanWealthServiceAuthControllerRegister = <
  TData = Common.RolanWealthServiceAuthControllerRegisterMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CreateUserDTO
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CreateUserDTO
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      RolanWealthService.authControllerRegister({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useRolanWealthServiceAuthControllerLogin = <
  TData = Common.RolanWealthServiceAuthControllerLoginMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: UserLoginDTO
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: UserLoginDTO
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      RolanWealthService.authControllerLogin({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useRolanWealthServiceAuthControllerLogout = <
  TData = Common.RolanWealthServiceAuthControllerLogoutMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<TData, TError, void, TContext>,
    'mutationFn'
  >,
) =>
  useMutation<TData, TError, void, TContext>({
    mutationFn: () =>
      RolanWealthService.authControllerLogout() as unknown as Promise<TData>,
    ...options,
  })
export const useOnboardingServiceOnboardingControllerOnboarding = <
  TData = Common.OnboardingServiceOnboardingControllerOnboardingMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: OnboardingDTO
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: OnboardingDTO
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      OnboardingService.onboardingControllerOnboarding({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useAdvisorServiceAdvisorControllerGrantAccess = <
  TData = Common.AdvisorServiceAdvisorControllerGrantAccessMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: GrantAdvisorAccessDto
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: GrantAdvisorAccessDto
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      AdvisorService.advisorControllerGrantAccess({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useAdvisorServiceAdvisorControllerRevokeAccess = <
  TData = Common.AdvisorServiceAdvisorControllerRevokeAccessMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: GrantAdvisorAccessDto
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: GrantAdvisorAccessDto
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      AdvisorService.advisorControllerRevokeAccess({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useAdvisorsServiceAdvisorGoalsControllerCreateGoalRecommendation =
  <
    TData = Common.AdvisorsServiceAdvisorGoalsControllerCreateGoalRecommendationMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: CreateGoalRecommendationDTO
          userId: number
        },
        TContext
      >,
      'mutationFn'
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: CreateGoalRecommendationDTO
        userId: number
      },
      TContext
    >({
      mutationFn: ({ requestBody, userId }) =>
        AdvisorsService.advisorGoalsControllerCreateGoalRecommendation({
          requestBody,
          userId,
        }) as unknown as Promise<TData>,
      ...options,
    })
export const useAdminWhitelistServiceAdminWhitelistControllerAddWhitelistedEmails =
  <
    TData = Common.AdminWhitelistServiceAdminWhitelistControllerAddWhitelistedEmailsMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: BulkWhitelistEmailsDTO
        },
        TContext
      >,
      'mutationFn'
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: BulkWhitelistEmailsDTO
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        AdminWhitelistService.adminWhitelistControllerAddWhitelistedEmails({
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    })
export const useAppointmentsServiceAppointmentsControllerCreateAppointment = <
  TData = Common.AppointmentsServiceAppointmentsControllerCreateAppointmentMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CreateAppointmentDTO
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CreateAppointmentDTO
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      AppointmentsService.appointmentsControllerCreateAppointment({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useAppointmentsServiceAppointmentsControllerWebhook = <
  TData = Common.AppointmentsServiceAppointmentsControllerWebhookMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<TData, TError, void, TContext>,
    'mutationFn'
  >,
) =>
  useMutation<TData, TError, void, TContext>({
    mutationFn: () =>
      AppointmentsService.appointmentsControllerWebhook() as unknown as Promise<TData>,
    ...options,
  })
export const useSupportServiceSupportControllerCreateTicket = <
  TData = Common.SupportServiceSupportControllerCreateTicketMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CreateSupportTicketDTO
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CreateSupportTicketDTO
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      SupportService.supportControllerCreateTicket({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useUserServiceUserControllerChangePassword = <
  TData = Common.UserServiceUserControllerChangePasswordMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ChangePasswordDTO
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ChangePasswordDTO
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      UserService.userControllerChangePassword({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useMessageServiceMessageControllerMarkThreadRead = <
  TData = Common.MessageServiceMessageControllerMarkThreadReadMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        recipientId: number
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      recipientId: number
    },
    TContext
  >({
    mutationFn: ({ recipientId }) =>
      MessageService.messageControllerMarkThreadRead({
        recipientId,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useTransactionServiceTransactionControllerBulkEditTransactions = <
  TData = Common.TransactionServiceTransactionControllerBulkEditTransactionsMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: BulkEditTransactionsDTO
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: BulkEditTransactionsDTO
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      TransactionService.transactionControllerBulkEditTransactions({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useTransactionServiceTransactionControllerToggleExcluded = <
  TData = Common.TransactionServiceTransactionControllerToggleExcludedMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        transactionId: number
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      transactionId: number
    },
    TContext
  >({
    mutationFn: ({ transactionId }) =>
      TransactionService.transactionControllerToggleExcluded({
        transactionId,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useTransactionServiceTransactionControllerEditTransaction = <
  TData = Common.TransactionServiceTransactionControllerEditTransactionMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: EditTransactionDTO
        transactionId: number
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: EditTransactionDTO
      transactionId: number
    },
    TContext
  >({
    mutationFn: ({ requestBody, transactionId }) =>
      TransactionService.transactionControllerEditTransaction({
        requestBody,
        transactionId,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useBankingServiceBankingControllerEditManualAccount = <
  TData = Common.BankingServiceBankingControllerEditManualAccountMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        accountId: string
        requestBody: StoreManualAccountDTO
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      accountId: string
      requestBody: StoreManualAccountDTO
    },
    TContext
  >({
    mutationFn: ({ accountId, requestBody }) =>
      BankingService.bankingControllerEditManualAccount({
        accountId,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useGoalsServiceGoalsControllerUpdate = <
  TData = Common.GoalsServiceGoalsControllerUpdateMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        goalId: number
        requestBody: CreateGoalDTO
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      goalId: number
      requestBody: CreateGoalDTO
    },
    TContext
  >({
    mutationFn: ({ goalId, requestBody }) =>
      GoalsService.goalsControllerUpdate({
        goalId,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useGoalsServiceGoalsControllerAcceptRecommendation = <
  TData = Common.GoalsServiceGoalsControllerAcceptRecommendationMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        recommendationId: number
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      recommendationId: number
    },
    TContext
  >({
    mutationFn: ({ recommendationId }) =>
      GoalsService.goalsControllerAcceptRecommendation({
        recommendationId,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useGoalsServiceGoalsControllerUpdateStep = <
  TData = Common.GoalsServiceGoalsControllerUpdateStepMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        goalId: number
        requestBody: UpdateGoalStepDTO
        stepId: number
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      goalId: number
      requestBody: UpdateGoalStepDTO
      stepId: number
    },
    TContext
  >({
    mutationFn: ({ goalId, requestBody, stepId }) =>
      GoalsService.goalsControllerUpdateStep({
        goalId,
        requestBody,
        stepId,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useGoalsServiceGoalsControllerReorderSteps = <
  TData = Common.GoalsServiceGoalsControllerReorderStepsMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        goalId: number
        requestBody: ReorderGoalStepsDTO
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      goalId: number
      requestBody: ReorderGoalStepsDTO
    },
    TContext
  >({
    mutationFn: ({ goalId, requestBody }) =>
      GoalsService.goalsControllerReorderSteps({
        goalId,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useNotificationsServiceNotificationControllerMarkAsRead = <
  TData = Common.NotificationsServiceNotificationControllerMarkAsReadMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        notificationId: number
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      notificationId: number
    },
    TContext
  >({
    mutationFn: ({ notificationId }) =>
      NotificationsService.notificationControllerMarkAsRead({
        notificationId,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useBudgetServiceBudgetControllerUpdateBudget = <
  TData = Common.BudgetServiceBudgetControllerUpdateBudgetMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        budgetId: number
        requestBody: CreateBudgetDTO
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      budgetId: number
      requestBody: CreateBudgetDTO
    },
    TContext
  >({
    mutationFn: ({ budgetId, requestBody }) =>
      BudgetService.budgetControllerUpdateBudget({
        budgetId,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useRolanWealthServiceAuthControllerResetPassword = <
  TData = Common.RolanWealthServiceAuthControllerResetPasswordMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CreateResetPasswordTokenDTO
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CreateResetPasswordTokenDTO
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      RolanWealthService.authControllerResetPassword({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useRolanWealthServiceVerifyControllerVerifyEmail = <
  TData = Common.RolanWealthServiceVerifyControllerVerifyEmailMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: VerifyEmailDTO
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: VerifyEmailDTO
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      RolanWealthService.verifyControllerVerifyEmail({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useRolanWealthServiceVerifyControllerVerifyResetPasswordToken = <
  TData = Common.RolanWealthServiceVerifyControllerVerifyResetPasswordTokenMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ResetPasswordDTO
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ResetPasswordDTO
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      RolanWealthService.verifyControllerVerifyResetPasswordToken({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useOnboardingServiceOnboardingControllerUpdateAnswers = <
  TData = Common.OnboardingServiceOnboardingControllerUpdateAnswersMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: OnboardingDTO
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: OnboardingDTO
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      OnboardingService.onboardingControllerUpdateAnswers({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useAdminUsersServiceAdminUsersControllerVerifyUser = <
  TData = Common.AdminUsersServiceAdminUsersControllerVerifyUserMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: VerifyUserAdminDTO
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: VerifyUserAdminDTO
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      AdminUsersService.adminUsersControllerVerifyUser({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useEmployerUsersServiceEmployerUsersControllerChangeRole = <
  TData = Common.EmployerUsersServiceEmployerUsersControllerChangeRoleMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ChangeUserRoleDTO
        userId: number
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ChangeUserRoleDTO
      userId: number
    },
    TContext
  >({
    mutationFn: ({ requestBody, userId }) =>
      EmployerUsersService.employerUsersControllerChangeRole({
        requestBody,
        userId,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useUserServiceUserControllerDeleteUser = <
  TData = Common.UserServiceUserControllerDeleteUserMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<TData, TError, void, TContext>,
    'mutationFn'
  >,
) =>
  useMutation<TData, TError, void, TContext>({
    mutationFn: () =>
      UserService.userControllerDeleteUser() as unknown as Promise<TData>,
    ...options,
  })
export const useBankingServiceBankingControllerDeleteManualAccount = <
  TData = Common.BankingServiceBankingControllerDeleteManualAccountMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        accountId: string
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      accountId: string
    },
    TContext
  >({
    mutationFn: ({ accountId }) =>
      BankingService.bankingControllerDeleteManualAccount({
        accountId,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useBankingServiceBankingControllerDeleteAccount = <
  TData = Common.BankingServiceBankingControllerDeleteAccountMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        accountId: string
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      accountId: string
    },
    TContext
  >({
    mutationFn: ({ accountId }) =>
      BankingService.bankingControllerDeleteAccount({
        accountId,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useGoalsServiceGoalsControllerDelete = <
  TData = Common.GoalsServiceGoalsControllerDeleteMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        goalId: number
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      goalId: number
    },
    TContext
  >({
    mutationFn: ({ goalId }) =>
      GoalsService.goalsControllerDelete({
        goalId,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useGoalsServiceGoalsControllerRejectRecommendation = <
  TData = Common.GoalsServiceGoalsControllerRejectRecommendationMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        recommendationId: number
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      recommendationId: number
    },
    TContext
  >({
    mutationFn: ({ recommendationId }) =>
      GoalsService.goalsControllerRejectRecommendation({
        recommendationId,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useGoalsServiceGoalsControllerDeleteStep = <
  TData = Common.GoalsServiceGoalsControllerDeleteStepMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        goalId: number
        stepId: number
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      goalId: number
      stepId: number
    },
    TContext
  >({
    mutationFn: ({ goalId, stepId }) =>
      GoalsService.goalsControllerDeleteStep({
        goalId,
        stepId,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useBudgetServiceBudgetControllerDeleteBudget = <
  TData = Common.BudgetServiceBudgetControllerDeleteBudgetMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        budgetId: number
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      budgetId: number
    },
    TContext
  >({
    mutationFn: ({ budgetId }) =>
      BudgetService.budgetControllerDeleteBudget({
        budgetId,
      }) as unknown as Promise<TData>,
    ...options,
  })
export const useAdminWhitelistServiceAdminWhitelistControllerDeleteWhitelistedEmails =
  <
    TData = Common.AdminWhitelistServiceAdminWhitelistControllerDeleteWhitelistedEmailsMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: BulkWhitelistEmailsDTO
        },
        TContext
      >,
      'mutationFn'
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: BulkWhitelistEmailsDTO
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        AdminWhitelistService.adminWhitelistControllerDeleteWhitelistedEmails({
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    })
export const useEmployerUsersServiceEmployerUsersControllerDeleteEmployee = <
  TData = Common.EmployerUsersServiceEmployerUsersControllerDeleteEmployeeMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        userId: number
      },
      TContext
    >,
    'mutationFn'
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      userId: number
    },
    TContext
  >({
    mutationFn: ({ userId }) =>
      EmployerUsersService.employerUsersControllerDeleteEmployee({
        userId,
      }) as unknown as Promise<TData>,
    ...options,
  })
